/**
 * Departments sit at the root of the site and the group_id the discovery API hands back is not
 * always the path. Six of them differ, so a crumb built as /browse/{group_id} lands on a second
 * copy of the department page. The other five read the same either way, and /browse/{department} is
 * in the redirect list in browse-plp-fe, which no crumb should point at. Both cases want the same
 * target, the department page itself, so every department is listed here.
 */
const departmentHrefs: Record<string, string> = {
  women: "/women",
  men: "/men",
  toys: "/toys",
  appliances: "/appliances",
  "designer-brands": "/designer-brands",
  "baby-and-kids": "/baby-kids",
  "sports-and-travel": "/sports-travel",
  "home-and-garden": "/home-garden",
  "gifts-and-jewellery": "/gifts-jewellery",
  "health-and-beauty": "/health-beauty",
  technology: "/technology-gaming",
};

/**
 * Href for a single crumb. Only the department, the first crumb after Home, has a page of its own -
 * everything below it is a browse URL. A department missing from the list falls back to the browse
 * URL too, so one added by merchandising still gets a link that works.
 */
const getCrumbHref = (groupId: string, isDepartment = false): string => {
  // a plain Record lookup reads the prototype chain, so group_id "constructor" or "__proto__" would
  // otherwise return a function/object that the template literal below stringifies into junk
  const departmentHref = isDepartment && Object.hasOwn(departmentHrefs, groupId) ? departmentHrefs[groupId] : "";
  return departmentHref || `/browse/${groupId}`;
};

export { departmentHrefs, getCrumbHref };
